// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"33f9fdbd","264":"3be98f42","418":"6a9e6f23","453":"37bdd1fd","480":"20063b5d","638":"e675e89c"}[chunkId] + ".chunk.js";
};